import React from 'react';

export default function Terms() {
  return (
    <div className="page">
      <h1>Terms & Conditions</h1>
      <p>
        Welcome to Dex — the ultimate music battle game where players face off in real-time song challenges and vote for the best picks. These Terms and Conditions ("Terms") govern your access to and use of the Dex mobile application and related services (collectively, the “Service”), provided by Dex Labs Ltd., a company registered in England and Wales with company number 14698745, registered at 71-75 Shelton Street, London, WC2H 9JQ, United Kingdom.
      </p>
      <p>
        By accessing or using Dex, you agree to be bound by these Terms. If you do not agree, do not use the Service.
      </p>

      <ol>
        <li>
          <strong>Eligibility</strong><br />
          To use Dex, you must be at least 13 years old. If you are under 18, you must have permission from a parent or legal guardian who agrees to these Terms on your behalf.
        </li>

        <li>
          <strong>Account Registration</strong><br />
          You may be required to create an account to participate in battles and track progress. When registering:
          <ul>
            <li>Provide accurate and complete information.</li>
            <li>Keep your login credentials secure.</li>
            <li>You are responsible for any activity under your account.</li>
          </ul>
          We reserve the right to suspend or delete accounts that violate our rules or are suspected of malicious activity.
        </li>

        <li>
          <strong>Gameplay and Fair Use</strong><br />
          Dex is a competitive social game. To keep it fair:
          <ul>
            <li>No cheating, exploiting bugs, or vote manipulation.</li>
            <li>No use of automated bots or scripts.</li>
            <li>No trolling, harassment, or disruptive behavior in chats or song picks.</li>
          </ul>
          Violation of these rules may result in a temporary or permanent ban.
        </li>

        <li>
          <strong>Music Licensing and Playback</strong><br />
          Dex does not stream or host music directly. Playback is powered via integrations with Spotify, Apple Music, and YouTube where available.
          <ul>
            <li>Users must have valid accounts on those platforms to stream full tracks.</li>
            <li>Dex displays album art, metadata, and links under API usage rights and fair use policies.</li>
            <li>We do not claim ownership over any third-party music or artwork.</li>
          </ul>
        </li>

        <li>
          <strong>Voting and Scoring</strong><br />
          Gameplay involves selecting songs to match prompts and voting for favorites. Final scores are determined using an Elo-inspired algorithm.
          <ul>
            <li>Voting is anonymous and final.</li>
            <li>Self-voting is disabled.</li>
            <li>Matchups and scores are not subject to appeal.</li>
            <li>Any manipulation or coordinated unfair voting will result in disqualification.</li>
          </ul>
        </li>

        <li>
          <strong>User-Generated Content</strong><br />
          You may contribute names, teams, and profile content. You agree not to post or submit anything:
          <ul>
            <li>Offensive, discriminatory, or sexually explicit</li>
            <li>Infringing on copyright or intellectual property</li>
            <li>Designed to impersonate others or mislead</li>
          </ul>
          We reserve the right to remove or edit any content at our discretion.
        </li>

        <li>
          <strong>Intellectual Property</strong><br />
          Dex and its features, visuals, branding, and software are owned by Dex Labs Ltd.
          <ul>
            <li>You may not copy, reverse engineer, or redistribute any part of the app or backend services.</li>
            <li>All third-party content (e.g. song metadata) remains the property of its respective owners.</li>
          </ul>
        </li>

        <li>
          <strong>Privacy and Data Use</strong><br />
          We collect limited personal data to operate the game and personalize your experience, as detailed in our Privacy Policy.
          <ul>
            <li>We do not sell your data to third parties.</li>
            <li>Data is stored securely on Google Cloud / Firebase infrastructure.</li>
          </ul>
        </li>

        <li>
          <strong>Termination</strong><br />
          We reserve the right to suspend or terminate your account without notice if:
          <ul>
            <li>You violate these Terms</li>
            <li>Your activity is harmful to other users or to the game ecosystem</li>
            <li>We are legally required to do so</li>
          </ul>
          You may also delete your account at any time via the app settings.
        </li>

        <li>
          <strong>Disclaimer of Warranties</strong><br />
          Dex is provided “as is”. We make no guarantees that:
          <ul>
            <li>The app will always be error-free or available</li>
            <li>You will have uninterrupted access to matches or features</li>
            <li>All music services will remain available or integrated</li>
          </ul>
          Use is at your own risk.
        </li>

        <li>
          <strong>Limitation of Liability</strong><br />
          To the fullest extent permitted by law:
          <ul>
            <li>Dex Labs Ltd. is not liable for any indirect, incidental, or consequential damages arising from your use of the Service.</li>
            <li>Our total liability shall not exceed £50 GBP.</li>
          </ul>
        </li>

        <li>
          <strong>Modifications</strong><br />
          We may revise these Terms from time to time. If changes are significant, we will notify you via in-app alerts or email. Continued use of Dex after updates means you accept the revised Terms.
        </li>

        <li>
          <strong>Governing Law</strong><br />
          These Terms are governed by the laws of England and Wales, and any disputes shall be resolved in the courts of London, UK.
        </li>

        <li>
          <strong>Contact</strong><br />
          For support or questions, contact us at:<br />
          <br />
          Dex Labs Ltd.<br />
          71-75 Shelton Street<br />
          London, WC2H 9JQ
        </li>
      </ol>
    </div>
  );
}
